
import { Options, Vue } from 'vue-property-decorator';
import Calculator from './tools/Calculator.vue';
import NotepadTool from './tools/Notepad.vue';

@Options({
  components: { NotepadTool, Calculator },
})
export default class PnpToolContainer extends Vue {}
